import React from 'react';
const noMore = ['No more guessing which system to build', 'No more searching everywhere for pH and EC information', 'No more wondering whether your roots look healthy', 'No more treating every crop the same', 'No more ignoring early warning signs', 'No more growing without a maintenance process', 'No more starting every problem from zero'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-sage-100 relative overflow-hidden" data-id="element-108" data-mp="m46pcjjah8pb">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-109" data-mp="h5veq6l66u61">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-8 leading-tight text-forest uppercase" data-id="element-110" data-mp="h5lpil7y8r1e">
          Next Month You Can Still Be Watching Random Hydroponics Videos...
          <br data-id="element-111" data-mp="qw6v4sm1ivtt" />
          <span className="text-leaf" data-id="element-112" data-mp="qxrowg0j6aqm">
            Or You Can Have a Complete Visual System Beside Your Grow.
          </span>
        </h2>
        <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white p-8 rounded-2xl border border-sage-200" data-id="element-113" data-mp="zwv8rm7iuu66">
          {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-114" data-mp="2c6r9g3ymy6m0">
              <span className="text-leaf mt-0.5" aria-hidden="true" data-id="element-115" data-mp="2h4sqykgexxvd">
                ▸
              </span>
              <span className="text-charcoal" data-id="element-116" data-mp="2m21d0w4omm1w">{item}</span>
            </div>)}
        </div>
        <p className="text-xl md:text-2xl font-bold text-forest mb-2" data-id="element-117" data-mp="2r2p0j7tpckrd">
          Hydroponics Grower Ready Doesn&apos;t Grow the Plants for You.
        </p>
        <p className="text-xl text-charcoal/80 mb-6" data-id="element-118" data-mp="302c5g3ln48p6">
          It gives you a complete visual system for growing with greater:
        </p>
        <p className="text-lg md:text-2xl font-extrabold tracking-widest text-leaf" data-id="element-119" data-mp="34un1gvd9facg">
          CONTROL · CLARITY · CONSISTENCY · INDEPENDENCE
        </p>
      </div>
    </section>;
}